
import { Component, Vue } from 'vue-property-decorator'

import { FacebookActionTypes } from '@/store/modules/facebook'

@Component
export default class FbLoginMixin extends Vue {
  created() {
    this.$store.dispatch(FacebookActionTypes.LoadSdk)
  }

  onFbConnect(redirectTo?: string) {
    this.$store.dispatch(FacebookActionTypes.Connect, redirectTo)
  }

  onFbLogin(redirectTo?: string) {
    this.$store.dispatch(FacebookActionTypes.Login, redirectTo)
  }

  onFbDisconnect() {
    this.$store.dispatch(FacebookActionTypes.Disconnect)
  }
}
